import * as React from "react";
import { Flex } from "@chakra-ui/react";
import { Navigate } from "react-router-dom";
import { useCurrentCase, useParams } from "duck";
import { Diagnosis, Header, Timer, Treatments } from "./components";

const Page = () => (
  <>
    <Header />
    <Flex mt="24px" direction="column" rowGap="24px">
      <Diagnosis />
      <Timer />
      <Treatments />
    </Flex>
  </>
);

const ToothDetails: React.FC = () => {
  const { toothNumber, id } = useParams();

  const hasDentalChart = useCurrentCase(({ data }) => {
    const charts = data.client.patient.dentalChartings;
    return !!charts?.find(chart => chart.tooth === +toothNumber);
  });

  if (!hasDentalChart) {
    return <Navigate to={`/cases/${id}/dental-charting`} replace />;
  }

  // Force remount when tooth number changes.
  return <Page key={toothNumber} />;
};

export default ToothDetails;
